{
  "Accessibility Menu": "Meni Za Pristupačnost",
  "Reset settings": "Resetuj postavke",
  "Close": "Zatvori",
  "Content Adjustments": "Podešavanje Sadržaja",
  "Adjust Font Size": "Podešavanje Veličine Fonta",
  "Highlight Title": "Označi Naslove",
  "Highlight Links": "Označi Veze",
  "Readable Font": "Čitljiviji Font",
  "Color Adjustments": "Podešavanje Boja",
  "Dark Contrast": "Tamni Kontrast",
  "Light Contrast": "Svijetli Kontrast",
  "High Contrast": "Visoki Kontrast",
  "High Saturation": "Velika Zasićenost",
  "Low Saturation": "Niska Zasićenost",
  "Monochrome": "Jednobojni",
  "Tools": "Alati",
  "Reading Guide": "Vodič Za Čitanje",
  "Stop Animations": "Zaustavi Animacije",
  "Big Cursor": "Veliki Kursor",
  "Increase Font Size": "Povećaj Veličinu Fonta",
  "Decrease Font Size": "Smanji Veličinu Fonta",
  "Letter Spacing": "Razmak Slova",
  "Line Height": "Visina Linije",
  "Font Weight": "Debljina Fonta",
  "Dyslexia Font": "Font Za Disleksičare",
  "Language": "Jezik",
  "Open Accessibility Menu": "Otvori Meni Za Pristupačnost"
}
